const pluralSingluarMap = Object.freeze({
  Audits: "Audit",
  audits: "audit",
});

export const pluralize = (count: number, pluralVersion: string): string => {
  if (count > 1) return pluralVersion;
  return pluralSingluarMap[pluralVersion as keyof typeof pluralSingluarMap];
};
